try {
window.Popper = require('./argon/core/popper.min').default;

/*
    require('./argon/core/bootstrap.min');
    require('./argon/argon-dashboard.min');
    require('./argon/plugins/perfect-scrollbar.min');
    require('./argon/inc'); */
} catch (e) {}
